import { Column } from '~components/table-view';

const columns: Column[] = [
  {
    id: 'name',
    header: 'Supplier Name',
    type: 'text',
  },
  {
    id: 'account_reference',
    header: 'Account Reference',
    type: 'text',
  },
];

export default columns;
